import _ from 'underscore';
import { getBulkApiErrors, CampaignApiError } from '@bingads-webui-campaign/api-errors';
import { notificationApi } from '@bingads-webui-react/notification-center';
import { generalError } from '@bingads-webui-campaign-react/recommendation-prefill';

export const ERROR_ENTITY = {
  Campaign: 'campaign',
  AssetGroup: 'assetGroup',
  CampaignLocation: 'campaignLocation',
  CampaignRadius: 'campaignRadius',
  CampaignNegativeLocation: 'campaignNegativeLocation',
  CampaignLocationIntent: 'campaignLocationIntent',
  CampaignDayTimeCriterion: 'campaignDayTimeCriterion',
  CampaignNegativeWebpage: 'campaignNegativeWebpage',
  AudienceGroupAssetGroupAssociation: 'audienceGroupAssetGroupAssociation',
};

const getFirstBulkErrorMessage = (response, i18n) => {
  if (!response || !response.errors) {
    return i18n.getString(generalError);
  }

  const errorsObj = getBulkApiErrors(response.errors, null, i18n);

  if (!errorsObj || !errorsObj[0] || !errorsObj[0].message) {
    return i18n.getString(generalError);
  }

  return errorsObj[0].message;
};

export const handleBulkErrors = (response, i18n, log) => {
  if (log) {
    log(`handleBulkErrors: response: ${JSON.stringify(response)}`);
  }
  notificationApi.showWarning(getFirstBulkErrorMessage(response, i18n));
};

export const showGeneralError = (i18n) => {
  notificationApi.showWarning(i18n.getString(generalError));
};

export const genericApiError = new CampaignApiError(generalError);

const getBulkUploadEntityType = entitySchema =>
  (entitySchema.properties['bulk-upload-type'] || {}).value ||
  entitySchema.name;

export const getBulkUploadErrorType = entitySchema =>
  `${getBulkUploadEntityType(entitySchema)} Error`;

export const mapBulkUpsertErrors
  = (errors, bulkUpsertEntityErrorMap, errorProcessor = _.identity, scenario, i18n, activityLogger) =>
    getBulkApiErrors(errors, scenario, i18n, activityLogger).map((error) => {
      const errorType = error.type;
      const mappedErrorType = _.result(bulkUpsertEntityErrorMap, errorType, errorType);
      // eslint-disable-next-line no-param-reassign
      error.type = mappedErrorType;
      return errorProcessor(error);
    });
